<div id="CallCentrePartialSaveModal" class="modal normal modal-example-call-centre" [ngClass]="showModal ? 'active' : ''">
  <form #partialInfoForm="ngForm" (ngSubmit)="saveDetails()">
    <span class="icon icon-cancel" id="closeButton" (click)="hide()"></span>
    <div class="form-control select" [ngClass]="partialInfoForm?.submitted && ddlPartialOperator.invalid ? 'error' : ''">
      <label>Operador</label>
      <div class="select-wrapper">
        <select class="inline" id="ddlPartialOperator" name="ddlPartialOperator" #ddlPartialOperator="ngModel" required [(ngModel)]="operator">
          <option value="" selected>Selecciona...</option>
          <option *ngFor="let operator of operatorModel" value="{{ operator.OperatorId }}">{{ operator.OperatorName }}</option>
        </select>
      </div>
      <p class="error" id="errorOperator">Por favor, selecciona una opción.</p>
    </div>
    <div class="form-control input">
      <label>Teléfono del usuario</label>
      <input
        type="text"
        required
        maxlength="9"
        class="text-input text-09-d-demibold"
        (keypress)="onKeyPress($event)"
        pattern="[0-9]*"
        [(ngModel)]="telephone"
        id="txtPartialTelephone"
        [ngClass]="partialInfoForm?.submitted && txtPartialTelephone.invalid ? 'error' : ''"
        name="txtPartialTelephone"
        #txtPartialTelephone="ngModel" />
      <p class="error-txt error" id="errorTelephone">Por favor, introduce un número de teléfono válido.</p>
    </div>
    <button id="partialSaveButton" class="btn solid-main next text-08-d-regular" type="submit" [class.hidden]="isDataSaved">GUARDAR</button>
    <div class="maintext text-04-m-demibold text-06-d-demibold" id="partialSaveMessageDiv" [class.hidden]="!isDataSaved">Datos guardados exitosamente.</div>
  </form>
</div>
